import Vue from 'vue';
import store from '../../store';
import equipmentTransformer from '../../transformers/equipment';

const success = ({ data }, resolve) => {
  const equipments = equipmentTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllEquipments', equipments);
  resolve(equipments);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/equipment')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/equipment/all.js